import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Stethoscope, ArrowRight } from "lucide-react";

interface ClinicianOnboardingProps {
  onComplete: (profileData: any) => Promise<void>;
}

export function ClinicianOnboarding({ onComplete }: ClinicianOnboardingProps) {
  const [formData, setFormData] = useState({
    practice_name: '',
    professional_title: '',
    standard_session_fee: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await onComplete({
        ...formData,
        standard_session_fee: formData.standard_session_fee ? Number(formData.standard_session_fee) : null
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="max-w-md w-full bg-card/50 border-border/30">
        <CardHeader className="text-center">
          <div className="h-16 w-16 rounded-full bg-primary/20 flex items-center justify-center mx-auto mb-4">
            <Stethoscope className="h-8 w-8 text-primary" />
          </div>
          <CardTitle className="text-2xl">Welcome to Therappi for Clinicians</CardTitle>
          <p className="text-muted-foreground">Set up your practice profile to get started</p>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label>Practice Name</Label>
            <Input 
              placeholder="e.g., Smith Therapy Practice"
              value={formData.practice_name}
              onChange={e => setFormData(p => ({ ...p, practice_name: e.target.value }))}
            />
          </div>
          <div className="space-y-2">
            <Label>Your Title</Label>
            <Input 
              placeholder="e.g., Clinical Psychologist"
              value={formData.professional_title}
              onChange={e => setFormData(p => ({ ...p, professional_title: e.target.value }))}
            />
          </div>
          <div className="space-y-2">
            <Label>Standard Session Fee (£)</Label>
            <Input 
              type="number"
              placeholder="e.g., 80"
              value={formData.standard_session_fee}
              onChange={e => setFormData(p => ({ ...p, standard_session_fee: e.target.value }))}
            />
          </div>
          <Button onClick={handleSubmit} disabled={loading} className="w-full gap-2">
            {loading ? 'Setting up...' : 'Get Started'}
            <ArrowRight className="h-4 w-4" />
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
